import { GroupType } from "./GroupType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity Roles


export interface Role {
    id: ID;

    
    name: string;

    
    scope?: string;

    
    description?: string;

    
    membersGroupId?: ID;

    }

export interface FilterAdvancedPresentationRequest {
    list: ListRequest,
    filter: {
        
            name?: string,
        
    
    

            scope?: string,
        
    
    scopeInclude: boolean,

            membersGroupId: ID[],
        
    
    membersGroupIdInclude: boolean,



        membersGroupIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}



export interface CreateRole {
    
    name: string;

    
    scope?: string;

    
    description?: string;

    
    membersGroupId?: ID;

    }


export interface UpdateRole {
    
    name: string;

    
    scope?: string;

    
    description?: string;

    
    }

export interface PresentationRoleRequest {
    list: ListRequest,
    filter: {
        name: string,
        nameOr: boolean,
        membersGroupIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryRole {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: Role): PrimaryRole | undefined {
        return entity ? new PrimaryRole(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryRole {
        return new PrimaryRole(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryRole {
        let vals = path?.split('/');
        return new PrimaryRole(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryRole[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: Role): string {
    let fields = entity ? [
    entity.name,
            ] : [];
    return fields.filter(item => item).join(' | ');
}

export class UpdateEntityRole {
    id: PrimaryRole;
    data: UpdateRole;


    constructor(id: PrimaryRole, data: UpdateRole) {
        this.id = id;
        this.data = data;
    }
}
